import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/button';

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <div className="flex-1 flex items-center justify-center pt-32 pb-20 px-4">
        <div className="max-w-lg w-full text-center bg-gray-50 rounded-lg border border-gray-200 p-10 shadow-lg" data-testid="payment-cancel-card">
          <XCircle className="mx-auto mb-6 text-gray-400" size={56} />
          <h1 className="text-2xl font-bold text-[#1e3a5f] mb-3">Payment Cancelled</h1>
          <p className="text-gray-600 mb-6">
            No payment was taken. You can return to the courses page whenever you're ready.
          </p>
          <Button asChild className="bg-[#dc2626] hover:bg-[#b91c1c] text-white font-semibold" data-testid="cancel-back-to-courses-btn">
            <Link to="/online-courses">Back to Courses</Link>
          </Button>
        </div>
      </div>
      <Footer />
    </div>
  );
}
